import React, { useState, useEffect, useContext } from "react";

import cx from "classnames";
import styles from "./teams.module.scss";
import { useDispatch } from "react-redux";
import {
  fetchTeamsDashboardReport,
  fetchTeamsLeaderboardReport,
  fetchTeamsLearnersReport,
  fetchTeamsLearningsReport,
  fetchTeamsMostEnrolledLearningsReport,
  fetchTeamsSkillReport,
} from "src/redux/actions/coaching/reports";
import DashboardMetrics from "./dashboard";
import LeaderboardReport from "./leaderboard";
import MostEnrolledReport from "./enrollments";
import LearnersReport from "./learners";
import LearningsReport from "./learnings";
import SkillsReport from "./skills";
import { CourseReportContext } from "../../context";

import _ from "lodash";

const TeamsReport = () => {
  const dispatch = useDispatch();

  const reportContext = useContext(CourseReportContext);

  useEffect(() => {
    const { user, userGroups, skills, startDate, endDate } = reportContext;

    const groupIds: string[] = _.map(userGroups, (group) => group.id) || [];
    const skillIds: string[] =
      _.map(skills, (skill) => skill.id as string) || [];

    const request = {
      page: 0,
      limit: 10,
      user: user,
      userGroups: groupIds,
      skills: skillIds,
      startDate: startDate,
      endDate: endDate,
    };

    dispatch(fetchTeamsDashboardReport(request));
    dispatch(fetchTeamsMostEnrolledLearningsReport(request));
    dispatch(fetchTeamsLearningsReport(request));
    dispatch(fetchTeamsLearnersReport(request));
    dispatch(fetchTeamsLeaderboardReport(request));
    dispatch(fetchTeamsSkillReport(request));
  }, [reportContext]);

  return (
    <div className={styles.container}>
      <DashboardMetrics />
      <LeaderboardReport />
      <SkillsReport />
      <MostEnrolledReport />
      <LearnersReport />
      <LearningsReport />
    </div>
  );
};

export default TeamsReport;
